import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    TranscriptDelete as TranscriptDeleteMutation,
    TranscriptDeleteVariables as TranscriptDeleteVariables,
    TranscriptDeleteInput,
} from 'nutshell-graphql-types';

import TRANSCRIPT_DELETE from '../mutations/delete-transcript.graphql';

export const useDeleteTranscript = (): {
    deleteTranscript: (arg1: TranscriptDeleteInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [deleteTranscript, {loading, error}] = useMutation<
        TranscriptDeleteMutation,
        TranscriptDeleteVariables
    >(TRANSCRIPT_DELETE);

    return {
        deleteTranscript: (input: TranscriptDeleteInput) => deleteTranscript({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
